module.exports = __webpack_public_path__ + "static/media/BiointeractiveLogo.4bbd8ce8.svg";